import { usarSiscred, type EncerramentoDoSiscred } from '../estado/siscred';

/**
 * RN-620 — O exercício vigente da operação de créditos recorrentes.
 *
 * A partir de 1º de julho, quem abre a plataforma está montando o exercício
 * seguinte: apura os SPEDs do ano corrente para fechar contratos que valem no
 * próximo (RN-619). Em 07/08/2026, o filtro traz 2027; em março, 2026.
 *
 * O SISCRED também vira a página (27/10/2026): marcado como encerrado na
 * Central de Configurações, o ano seguinte vale dali em diante — o que vier
 * primeiro, julho ou o encerramento.
 *
 * É a mesma regra de `packages/domain/src/shared/exercicio.ts`. Duplicada aqui
 * de propósito: o web não importa o domínio — a API é a fronteira —, e uma
 * função de poucas linhas não justifica abrir essa exceção. Se a regra mudar,
 * muda nos dois.
 */
export function exercicioVigente(
  hoje: Date = new Date(),
  encerramentos: readonly EncerramentoDoSiscred[] = usarSiscred.getState().encerramentos,
): number {
  const ano = hoje.getFullYear();
  const peloCalendario = hoje.getMonth() >= 6 ? ano + 1 : ano;
  const encerrouEsteAno = encerramentos.some(
    (e) => e.ano === ano && e.encerradoEm.getTime() <= hoje.getTime(),
  );
  return encerrouEsteAno ? Math.max(peloCalendario, ano + 1) : peloCalendario;
}

/** O exercício vigente numa tela — e a tela muda junto quando o SISCRED é marcado. */
export function useExercicioVigente(): number {
  return usarSiscred((s) => exercicioVigente(new Date(), s.encerramentos));
}
